<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="8">
        <v-skeleton-loader v-if="loading" type="list" />
        <ToolProcessHistory :processes="processes" :is-tool-view="true" v-else/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
import ToolProcessHistory from "../../components/Systems/ToolProcessHistory";
export default {
  name: "ToolRecentRunsView",
  components: {ToolProcessHistory},
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    processes() {
      return ToolProcess.query()
        .where("completed", true)
        .where("tool_id", this.id)
        .with("tool")
        .with("workorder")
        .orderBy("in_process_end", 'desc')
        .get();
    }
  },
  mounted() {
    this.loading = true;
    ToolProcess
      .$fetchByTool(this.id)
      .then(() => this.loading = false)
  }
}
</script>
